var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcoming({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E4E4E4",
    fillRule: "nonzero",
    cx: 52.92,
    cy: 52.92,
    r: 52.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.651 82.594H28.669v-21.8h53.982a4.538 4.538 0 0 1 4.538 4.538v12.724a4.538 4.538 0 0 1-4.538 4.538z",
    fill: "#ECECEC",
    fillRule: "nonzero",
    stroke: "#D3D3D3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.913 60.793H35.635l2.822-16.344H74.05a4.788 4.788 0 0 1 4.725 3.963l2.138 12.381z",
    fill: "#F6F6F6",
    fillRule: "nonzero",
    stroke: "#D3D3D3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.632 91.236a4.096 4.096 0 0 1-4.096-4.096v-4.462h8.192v4.462a4.096 4.096 0 0 1-4.096 4.096z",
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#D3D3D3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.435,
    cy: 4.61,
    r: 4.063,
    transform: "translate(72.736 66.907)",
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#D3D3D3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.056 12)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.79 4.664a1.365 1.365 0 0 1-1.365-1.366V1.367a1.365 1.365 0 0 1 2.731 0v1.931c0 .754-.611 1.366-1.365 1.366zM6.79 12.39a1.365 1.365 0 0 1-1.365-1.365V9.094a1.365 1.365 0 0 1 2.731 0v1.931c0 .754-.611 1.365-1.365 1.365zM3.893 7.562H1.961a1.365 1.365 0 0 1 0-2.731h1.932a1.365 1.365 0 0 1 0 2.73zM11.62 7.562H9.688a1.365 1.365 0 0 1 0-2.731h1.932a1.365 1.365 0 0 1 0 2.73z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9B9B9",
    cx: 13.108,
    cy: 27.724,
    r: 1.46
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 18.505)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.542 71H4.783a4.418 4.418 0 0 1-4.418-4.418V5.786a4.418 4.418 0 0 1 4.418-4.418h30.759a4.418 4.418 0 0 1 4.418 4.418v60.796A4.418 4.418 0 0 1 35.542 71z",
    stroke: "#D3D3D3",
    strokeWidth: 2,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.128 56H7.103c-2.064 0-3.738-1.335-3.738-2.982V11.982C3.365 10.335 5.04 9 7.103 9h26.024c2.065 0 3.738 1.335 3.738 2.982v41.036c0 1.647-1.673 2.982-3.737 2.982z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B4F5B",
    d: "M17.734 5.464h4.858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.592 6.83h-4.859a1.365 1.365 0 0 1 0-2.731h4.859a1.365 1.365 0 0 1 0 2.73z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3D3D3",
    cx: 20.163,
    cy: 63.491,
    r: 3.413
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#B6B6B6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.083 32.085c0 4.794-8.474 16.12-8.474 16.12s-8.473-11.326-8.473-16.12c0-4.794 3.793-8.68 8.473-8.68 4.68 0 8.474 3.886 8.474 8.68z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.384 27.82)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.225,
    cy: 4.265,
    rx: 3.784,
    ry: 3.877
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.e5d282b9771539f03e2cb67921f5cebc.svg";
export { ForwardRef as ReactComponent };